<template lang="html">
  <div class="fullScreen index">
    <common-header></common-header>
    <div class="page">
      <div class="wrapper-content">
        <div class="ibox-title">
          <div class="btn btn-info" @click="$router.push('/joinNotice')">
            新申请
          </div>
        </div>
        <div class="box">
          <div class="row table-content">
            <div class="col-sm-12" role="region" aria-labelledby="caption" tabindex="0">
              <table class="table">
                <thead class="">
                  <tr scope="row" class="text-center">
                    <th scope="col">协会名称</th>
                    <th scope="col">申请时间</th>
                    <th scope="col">状态</th>
                    <th scope="col">备注</th>
                    <th scope="col" style="width:25%;min-width:245px;">操作</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="text-center" v-for="item in list">
                    <th scope="row">{{ item.union }}</th>
                    <td>{{ item.intime }}</td>
                    <td><span :class="item.statusCode == 0 ? 'state1' : item.statusCode == 1 ? 'state2' : 'state3'">{{
                      item.status }}</span>
                    </td>
                    <td>{{ item.remark }}</td>
                    <td><a href="" @click.stop.prevent="goEdit(item.id, item.statusCode)"
                        :class="item.statusCode == 0 || item.statusCode == 4 || item.statusCode == 3 || item.statusCode == 5 ? '' : 'noEdit'">修改</a><span
                        v-if="item.statusCode == 0 || item.statusCode == 3 || item.statusCode == 5">|</span>

                      <!-- <a href="" @click.stop.prevent="goEdit(item.id, item.statusCode)"
                        v-if="item.statusCode == 2">完善资料</a><span v-if="item.statusCode == 2">|</span> -->


                      <a href="" @click.stop.prevent="goDetail(item.id)">查看</a>
                      <!-- |<a href @click="print(item.id)"
                        v-if="item.statusCode == 4 || item.statusCode == 2">打印</a> -->
                      |<a href @click="vip(item.id)" v-if="item.statusCode == 4">会员证</a><span
                        v-if="item.statusCode == 4">|</span>
                      <a class="red" @click="removeApply(item.id)">删除</a>

                      <a href v-if="item.isPaid == 0 && item.canpay == 1" @click.stop.prevent="pay(item.id)">缴费</a>
                    </td>
                  </tr>
                  <!-- <tr class="text-center">
                    <th scope="row">作家协会</th>
                    <td>2019-02-26</td>
                    <td><span class="state2">待审核</span></td>
                    <td><a href="#">查看</a>|<a href="#">打印</a></td>
                  </tr>
                  <tr class="text-center">
                    <th scope="row">作家协会</th>
                    <td>2019-02-26</td>
                    <td><span class="state3">初审通过</span></td>
                    <td><a href="#">查看</a></td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <page-ctrl v-bind:totalPage="totalPage" v-bind:currentPage="currentPage"
              v-on:catchPage="catchPage"></page-ctrl>
            <!-- <nav aria-label="Page navigation example">
              <ul class="pagination">
                <li class="page-item"><a class="page-link" @click="changePage(0,1)">上一页</a></li>
                <li class="page-item" v-for="item in pageList" @click="changePage(item,2)"><a class="page-link" :class="currentPage==item?'active':''">{{item}}</a></li>
                <li class="page-item"><a class="page-link" @click="changePage(0,3)">下一页</a></li>
              </ul>
            </nav> -->
          </div>
        </div>
      </div>

    </div>
    <alert-model v-bind:show="alertShow" v-bind:func="alertFunc" v-on:close="catchClose" v-bind:msg="tips"></alert-model>

    <div class="alert" v-show="payFlag">
      <div class="alertModel">
        <h5>微信扫码缴费 <span @click="canclePay">×</span></h5>
        <div class="content">
          <p style="margin-bottom: 10px;">订单号：{{ trade_no }}</p>
          <!-- <p>支付金额：</p> -->
          <img :src="'data:image/png;base64,' + imgurl" />
        </div>
        <div class="bottom">
          <div class="btn btn-light" @click="canclePay">
            关闭
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonHeader from './header.vue'
import pageCtrl from './pagination.vue'
import alertModel from './alert.vue'
export default {
  data() {
    return {
      list: [],
      totalPage: 0,
      currentPage: 0,
      alertShow: false,
      tips: '',
      alertFunc: '',
      timers: '',
      payFlag: false,
      imgurl: '',
      trade_no: ''
    }
  },
  methods: {
    alert(msg, func) {
      this.alShow = true
      this.altips = msg
      if (typeof func === 'function') {
        func()
      }
    },
    goEdit(id, status) {
      if (status == 2) {
        this.$router.push({ path: '/complete', query: { id: id } })
        return;
      }
      if (status == 0 || status == 3 || status == 5 || status == 4) {
        if (status == 4) {
          this.$router.push({ path: '/edit2', query: { id: id } })
        } else {
          this.$router.push({ path: '/edit', query: { id: id } })
        }
      }
    },
    catchClose(data) {
      this.alertShow = data.show
    },
    alert(msg, func) {
      this.alertShow = true
      this.tips = msg
      this.alertFunc = func
    },
    print(id) {
      window.open(`//app.shiminjia.com/api/wenlian/print?id=${id}`)
    },
    vip(id) {
      window.open(`//app.shiminjia.com/api/wenlian/card?id=${id}`)
    },
    pay(id) {
      this.$axios.get(`/api/wenlian/paycode?id=${id}`).then(res => {
        if (res.data.result == 1) {
          this.payFlag = true
          this.imgurl = res.data.data
          this.trade_no = res.data.msg
          this.timers = setInterval(this.getOrderstate, 1000)
        } else {
          this.alert(res.data.msg)
        }
        console.log(res.data)
      })
    },
    // 调用一个判断支付是否成功的接口，用这个接口我们监听微信是否支付成功
    getOrderstate(no) {
      this.$axios.get(`/api/wenlian/paycheck?trade_no=${this.trade_no}`).then(res => {
        console.log(res.data)
        if (res.data.result == 1) {
          this.alert('支付成功!')
          clearInterval(this.timers)
          this.canclePay()
        }
      })
    },
    canclePay() {
      this.payFlag = false
      clearInterval(this.timers)
    },
    goDetail(id) {
      //this.$router.push({ path: '/detail', query: { id: id } })
      this.$router.push({ path: '/table', query: { id: id } })
    },
    removeApply(id) {
      let params = {
        id: id
      }
      this.$axios.post('/api/wenlian/delrequest', this.qs.stringify(params)).then(res => {
        if (res.data.result == 1) {
          this.alert('删除成功', () => {
            window.location.reload()
          })
        } else {
          this.alert(res.data.msg)
        }
      })
    },
    catchPage(data) {
      let p = data.p
      console.log(data)
      this.$axios.get(`/api/wenlian/requestlist?page=${p}`).then(res => {
        this.list = res.data.data
        this.totalPage = res.data.sumpage
        this.currentPage = res.data.curpage
      })
    }
  },
  computed: {

  },
  components: {
    commonHeader,
    pageCtrl,
    alertModel
  },
  mounted() {
    if (this.$store.state.user.role != 3) {
      this.$router.push('/dataTypein')
    }
    this.$axios.get(`/api/wenlian/requestlist?page=1`).then(res => {
      this.list = res.data.data
      this.totalPage = res.data.sumpage
      this.currentPage = res.data.curpage

      // this.list = [{ "id": "88", "userid": "1", "union": "\u9752\u5c9b\u5e02\u6444\u5f71\u5bb6\u534f\u4f1a", "intime": "2020-09-16 08:00", "name": "\u6d4b\u8bd5", "status": "\u5df2\u7f34\u8d39", "remark": "\u521d\u5ba1\u901a\u8fc7\u8bf7\u7f34\u8d39\u540e\u6253\u5370\u8868\u683c--\u534f\u4f1a\u79d8\u4e66\u957f\u8054\u7cfb\u7535\u8bdd\uff1a\u8d75\u9e4f\u98de 85916751", "editable": 1, "isPaid": 1, "statusCode": 2 }]

      if (this.list) {
        this.list.forEach(item => {
          //console.log(item.status)
          if (item.statusCode == 2) {
            if (item.firstReviewRemarks) {
              this.alert(item.firstReviewRemarks);
            } else {
              this.alert(`<p>您的初审已通过，请于初审通过之日起15日内打印会员登记申请表（双面打印）、两张两寸证件照片、相关证书复印件及各协会要求携带的相关材料送至协会秘书长处。</p> <p>${item.remark}</p><p>服务监督电话：85916751</p>`)
            }
            return
          }
        })
      }
    })
  }
}
</script>

<style lang="css" scoped>
.index .btn {
  padding-left: 40px;
  padding-right: 40px;
}

.index.fullScreen {
  height: 100%;
}

.index .table {
  border: 1px solid #33434b;
}

.index .table tbody tr:nth-child(2n) {
  background: #fff;
}

.index .table tbody tr:nth-child(2n-1) {
  background: #f9f9f9;
}

.index .state1 {
  color: #333;
}

.index .state2 {
  color: red;
}

.index .state3 {
  color: green;
}

.index td>a {
  margin: 0 10px;
}

.index thead {
  background: #fff;
  color: #33434b;
}

.index tbody,
.page-link {
  color: #33434b;
}

.index .page-link:hover {
  background: #f4f4f4;
  color: #33434b;
}

.index .page-link.active {
  background: #f4f4f4;
}

.index .table thead th {
  vertical-align: middle;
}

.index .table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #33434b;
}

.index .red {
  color: red !important;
}

.noEdit {
  color: #999;
  opacity: 0;
  cursor: default;
}

.noEdit:hover {
  color: #999;
  text-decoration: none;
  opacity: 0;
  cursor: default;
}

.page {
  padding: 20px 0;
}

.wrapper-content {
  max-width: 1400px;
  margin: 0 auto;
}

.alert {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  z-index: 99999;
}

.alertModel {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  min-height: 100px;
  background: #fefefe;
  border-radius: 5px;
  border: 1px solid #ced4da;
}

.alertModel h5 {
  text-align: center;
  font-size: 16px;
  padding: 10px 20px;
  border-bottom: 1px solid #e9ecef;
  color: #33434b;
  margin-bottom: 0;
}

.alertModel h5 span {
  float: right;
  font-size: 24px;
  margin-top: -10px;
}

.alertModel .content {
  text-align: center;
  font-size: 15px;
  padding: 20px 20px;
  line-height: 1.7;
  color: #666;
}

.alertModel .content p {
  margin-bottom: 0;
}

.alertModel .content img {
  width: 200px;
  height: 200px;
}

.alertModel .bottom {
  text-align: center;
  padding: 10px 0;
}

.alertModel .bottom span {}

.alertModel .btn {
  width: 120px;
}

@media only screen and (max-width: 750px) {
  .box {
    padding: 20px 10px !important;
  }

  .ml-md-auto {
    margin: 0 auto;
  }

  .table-content {
    margin: 0;
  }

  .table {
    width: 1200px;
    table-layout: fixed;
    border: none !important;
    border-collapse: separate;
    border-spacing: 0;
  }

  .table thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    /* width: 25vw; */
    /* box-shadow: 0 0 0.8em rgba(0, 0, 0, 0.5); */
    background: white;
  }

  .table thead th:first-child {
    position: sticky;
    left: 0;
    z-index: 10;
    border-left: 1px solid #a9afb5;
    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
    width: 15%;
    /* box-shadow: 0 0 0.8em rgba(0, 0, 0, 0.5); */
  }

  .table thead th:last-child {
    width: 20% !important;
    min-width: auto !important;
  }

  .table tbody th {
    position: sticky;
    left: 0;
    background: white;
    z-index: 9;
    border-left: 1px solid #a9afb5;
    box-shadow: 0 0 10px rgb(0 0 0 / 12%);
  }

  [role='region'][aria-labelledby][tabindex] {
    /* width: 450px; */
    height: 400px;
    overflow: auto;
    padding: 0;
    outline: 0;
  }

  .table td,
  .table th {
    white-space: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue